// extracted by mini-css-extract-plugin
export var cancelButton = "_pi-5";
export var content = "_pi-3";
export var createButton = "_pi-6";
export var drawerContainer = "_pi-0";
export var footer = "_pi-2";
export var header = "_pi-1";
export var orderFormColumn = "_pi-4";